/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Chip de filtro aplicado con acción de quitar (patrón Polaris / Shopify).
 */
import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ticketColors } from '../theme/public-api';
import { operationalFilterStyles as styles } from './operationalFilters.styles';

type Props = {
  label: string;
  onDismiss: () => void;
  accessibilityLabel?: string;
  testID?: string;
  ticketTone?: boolean;
};

export function OperationalFilterDismissChip({
  label,
  onDismiss,
  accessibilityLabel,
  testID,
  ticketTone = true,
}: Props) {
  const a11y = accessibilityLabel ?? `Quitar filtro ${label}`;

  return (
    <TouchableOpacity
      style={[
        styles.chip,
        styles.dismissChipInner,
        ticketTone && styles.chipTicket,
        ticketTone ? styles.chipActiveTicket : styles.chipActive,
      ]}
      onPress={onDismiss}
      accessibilityRole="button"
      accessibilityLabel={a11y}
      testID={testID}
    >
      <Text
        style={[
          styles.chipText,
          ticketTone && styles.chipTextTicket,
          ticketTone ? styles.chipTextActiveTicket : styles.chipTextActive,
          styles.dismissChipLabel,
        ]}
        numberOfLines={1}
      >
        {label}
      </Text>
      <Ionicons
        name="close"
        size={14}
        color={ticketTone ? ticketColors.goldInk : '#FFFFFF'}
        accessibilityElementsHidden
        importantForAccessibility="no"
      />
    </TouchableOpacity>
  );
}
